module.exports = __webpack_public_path__ + "static/9-08a83fe96f3f43a214370997c827d19d.jpg";